import React, { useState, useEffect, useRef } from 'react'; 

import { Carousel, Card, Col, Row } from 'antd';
import { ShoppingCartOutlined,CarOutlined ,  ClockCircleOutlined, TagOutlined } from '@ant-design/icons'; // Import the required icons
import Offers from './Offers';
import Daily from './Daily';
import { useNavigate } from 'react-router-dom';
import './Home.css'; // For custom CSS


const banners = [
  'https://firebasestorage.googleapis.com/v0/b/dollar-eda6d.firebasestorage.app/o/profile%2FChatGPT%20Image%20Jun%2014%2C%202026%2C%2012_50_51%20PM.png?alt=media&token=3820bf8b-1872-431e-91be-3add00710120',
  'https://firebasestorage.googleapis.com/v0/b/erps-cdea6.firebasestorage.app/o/logo%2FShop%20New%20Products%20Website%20Banner%20Brown%2C%20White%2C%20Tan%20(16)%20(1).png?alt=media&token=0f82fa01-5261-40c5-8fb6-ce49cc77f437',
  'https://firebasestorage.googleapis.com/v0/b/erps-cdea6.firebasestorage.app/o/logo%2FShop%20New%20Products%20Website%20Banner%20Brown%2C%20White%2C%20Tan%20(16).png?alt=media&token=f1544dd8-720c-47ab-b6b5-691d2dfa4c43',
  'https://firebasestorage.googleapis.com/v0/b/erps-cdea6.firebasestorage.app/o/logo%2FShop%20New%20Products%20Website%20Banner%20Brown%2C%20White%2C%20Tan%20(14).png?alt=media&token=d9ac672c-715b-406d-9fe7-0371502e3e2a',
];

const rowImages = [
  'https://firebasestorage.googleapis.com/v0/b/erps-cdea6.firebasestorage.app/o/logo%2FShop%20New%20Products%20Website%20Banner%20Brown%2C%20White%2C%20Tan%20(12).png?alt=media&token=a9836caf-b374-4b99-8b83-b4778c2ba026',
  'https://firebasestorage.googleapis.com/v0/b/erps-cdea6.firebasestorage.app/o/got%2FNew%20Arrival.png?alt=media&token=868acb6b-fcde-474a-951c-ba090114dacd',
];

const videoURL = 'https://firebasestorage.googleapis.com/v0/b/erps-cdea6.firebasestorage.app/o/got%2FNew%20Arrival.mp4?alt=media&token=5472c7a3-df95-4380-aa3b-2873296fce99'; // Replace with your video URL

function Home() {
  const [currentBanner, setCurrentBanner] = useState(0);
  const [clickedImage, setClickedImage] = useState(null);
  const navigate = useNavigate();
  const blogRowRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner((prevBanner) => (prevBanner + 1) % banners.length);
    }, 10000); // Change banner every 6 seconds

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      if (blogRowRef.current) {
        // Scroll to the next blog card
        const scrollWidth = blogRowRef.current.scrollWidth;
        const clientWidth = blogRowRef.current.clientWidth;
        const currentScroll = blogRowRef.current.scrollLeft;

        if (currentScroll + clientWidth >= scrollWidth) {
          // If we've reached the end, scroll to the start
          blogRowRef.current.scrollLeft = 0;
        } else {
          // Scroll by 300px smoothly
          blogRowRef.current.scrollBy({ left: 300, behavior: 'smooth' });
        }
      }
    }, 5000); // Scroll every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const handleCardClick = (blog) => {
    navigate(`/blog`, { state: { blog } });
  };

  const handleImageClick = (image) => {
    setClickedImage(image);
    alert(`Image clicked: ${image}`);
  };

  const blogData = [
    {
      id: 1,
      title: "Modern Furniture for Stylish Living",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkDou0_Tywj0JJetyAU-HJ-V1I9aWXKapF4g&s",
    },
    {
      id: 2,
      title: "Luxury Furniture for Elegant Homes",
      image: "https://blog.luxury-italianfurniture.com/hubfs/luxury-living-room-furniture-ideas-lif.jpg",
    },
  
    {
      id: 4,
      title: "Innovative Storage Solutions",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxqqvoKadaO7K2DlDUpNG1PcaTQ0hAiLY9VA&s",
    },
    {
      id: 5,
      title: "Outdoor Furniture Trends",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSa5dREUunmkqVjE4oFvF-4dNdAbdt1lTws-w&s",
    },
   
  ];

  return (
    <div style={{ width: '100%', maxWidth: '1600px', margin: '0 auto', padding: '20px' }}>
      {/* Banner Slider */}
      <Carousel autoplay dotPosition="bottom" afterChange={(current) => setCurrentBanner(current)}>
        {banners.map((banner, index) => (
          <div key={index}>
            <img
              src={banner}
              alt={`Banner ${index + 1}`}
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '500px',
                objectFit: 'cover',
                borderRadius: '10px',
              }}
            />
          </div>
        ))}
      </Carousel>

      {/* Row of Cards with Icons */}
      

      {/* Row of Images Below Banner */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '16px',
          marginTop: '20px',
          flexWrap: 'wrap',
        }}
      >
        {rowImages.map((image, index) => (
          <div
            key={index}
            style={{
              flex: '1 1 calc(50% - 16px)', // Take 50% width minus the gap on small screens
              maxWidth: 'calc(50% - 16px)',
              cursor: 'pointer',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            }}
            onClick={() => handleImageClick(image)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <img
              src={image}
              alt={`Row Image ${index + 1}`}
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '10px',
                objectFit: 'cover',
              }}
            />
          </div>
        ))}
      </div>

      <h3 style={{ textAlign: 'center', marginTop: '40px', fontSize: '2rem', fontWeight: 'bold' }}>Dollar Furniture</h3>


      <Offers />

      {/* Video Banner Below Offers */}
      <div
        style={{
          marginTop: '40px',
          borderRadius: '10px',
          overflow: 'hidden',
        }}
      >
        <video
          src={videoURL}
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '500px',
            objectFit: 'cover',
          }}
        />

        <Daily/>
<div style={{ marginTop: '40px' }}>
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} sm={8}>
            <Card
              hoverable
              style={{
                width: '100%',
                textAlign: 'center',
                borderRadius: '10px',
                padding: '20px',
              }}
              cover={<CarOutlined  style={{ fontSize: '50px', color: 'orange' }} />}
            >
              <h3>Fast Delivery</h3>
              <p>Shipping Countrywide</p>
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card
              hoverable
              style={{
                width: '100%',
                textAlign: 'center',
                borderRadius: '10px',
                padding: '20px',
              }}
              cover={<ClockCircleOutlined style={{ fontSize: '50px', color: 'orange' }} />}
            >
              <h3>24 X 7 Service</h3>
              <p>Online Service For New Customer</p>
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card
              hoverable
              style={{
                width: '100%',
                textAlign: 'center',
                borderRadius: '10px',
                padding: '20px',
              }}
              cover={<TagOutlined style={{ fontSize: '50px', color: 'orange' }} />}
            >
              <h3>Festival Offer</h3>
              <p>New Online Special Festival Offer</p>
            </Card>
          </Col>
        </Row>
      </div>
       
      </div>

      <h2 style={{ textAlign: 'center', marginTop: '40px', fontSize: '2rem', fontWeight: 'bold' }}>Our Blog</h2>

       {/* Blog Cards Row */}
       <div className="blog-row" ref={blogRowRef}>
        {blogData.map((blog) => (
          <Card
            key={blog.id}
            hoverable
            onClick={() => handleCardClick(blog.id)}
            cover={<img src={blog.image} alt={blog.title} className="blog-image" />}
            style={{
              width: '300px',
              margin: '10px',
              borderRadius: '10px',
            }}
          >
            <Card.Meta title={blog.title} />
          </Card>
        ))}
      </div>


    </div>
  );
}

export default Home;
